import React, { Component } from 'react'
import { graphql, withApollo, compose } from 'react-apollo'
import { translate } from 'react-i18next'
import gql from 'graphql-tag'
import get from 'lodash/get'
import isEmpty from 'lodash/isEmpty'
import moment from 'moment'
import clone from 'lodash/cloneDeep'
import omit from 'lodash/omit'
import { deepOmit } from './../../libs/utils'

import PropTypes from 'prop-types'

import {validateRequired} from '../../libs/validation';
import Loader from "../UI/Loader";
import {Form, TextInput, SelectInput} from '../UI'

import config from './../../config'

import {
    UPDATE_ITINERARY_DAY,
    LOAD_USER_PROFILE_BY_EMAIL,
    LOAD_USER_PROFILE_BY_PHONE,
    GET_CUSTOMIZED_PLANS_LIST
  } from './../../graphql/MyTrips'

  import queries from './../../graphql/TripForm'

  import queriesTP from './../../graphql/TripPlanner'

  

class PrepaidTrip extends Component {
    static propTypes = {
      data: PropTypes.object,
      user: PropTypes.object,
      allCustomizedPlansQuery: PropTypes.shape({
        loading: PropTypes.bool,
        allCustomizedPlans: PropTypes.array,
        refetch: PropTypes.func
      }),
      createAllItineraryDays: PropTypes.func,
      updateItineraryDay: PropTypes.func,
      createTripDetails: PropTypes.func,
      createCustomizedPlan: PropTypes.func
    }

  constructor() {
    super()
    this.state = {
      firstName: '',
      lastName: '',
      email: '',
      phone: '',
      waiting: false
    }
  }

    getPlanOptions = () => {
        const options = [];
        if (!this.props.allCustomizedPlansQuery.loading) {
            this.props.allCustomizedPlansQuery.customizedplan.map(plan => {
                moment(plan.startDate).toISOString()
                options.push({
                label: plan.tripDetails.title + ' (' + 
                    moment(plan.startDate).format('MMM D') + '-' + moment(plan.endDate).format('MMM D') + ')',
                value: plan.id
                });
            })
        }
        return options;
    }

    getSelectedPlan = async (planId) => {
        let queryResult = await this.props.client
        .query({
          query: loadSelectedPlan,
          variables: {
            id: planId
          }
        })
        console.log(queryResult)
        return queryResult.data.CustomizedPlan
    }

    copyExistingPlan = async (sourceId, userId) => {

        let source = await this.getSelectedPlan(sourceId)
    
        const sourceCopy = clone(source)
    
        delete sourceCopy.id
    
        sourceCopy.tripDetails.title = '[copy] ' + sourceCopy.tripDetails.title
    
        delete sourceCopy.travelers

        let flatItineraryDays = []
    
        sourceCopy.tripDetails.itineraryDays.forEach(day => {
          delete day.id

          const sourceDay =
            source.tripDetails.itineraryDays.find(({ index }) => index === day.index)
    
          const diff =
            moment(day.dayOfTrip).diff(moment(sourceDay.dayOfTrip), 'days')

          // Clone the events
          const events = clone(sourceDay.contentEvents)          
          
          events.forEach(event => {
            if (!isEmpty(event.defaultPhoto)) {
              event.defaultPhotoId = event.defaultPhoto.id
            }
    
            if (Array.isArray(event.docs) && event.docs.length) {
              event.docsIds = event.docs.map(doc => doc.id)
            }
    
            if (Array.isArray(event.photos) && event.photos.length) {
              event.photosIds = event.photos.map(photo => photo.id)
            }
    
            delete event.defaultPhoto
    
            event.startDate = moment(event.startDate).add(diff, 'days').toISOString()
            event.endDate = moment(event.endDate).add(diff, 'days').toISOString()
    
            event.docs = []
            event.photos = []
          })
    
          day.contentEvents = deepOmit(events, ['id', '__typename'])

          let flatDay = deepOmit(day, ['contentEvents', 'notes', '__typename'])
          flatItineraryDays.push(flatDay)
        })


        delete sourceCopy.tripDetails.id
        delete sourceCopy.tripDetails.__typename
        sourceCopy.tripDetails.itineraryDays = Object.values(omit(sourceCopy.tripDetails.itineraryDays, ['id', '__typename']))


        // Now need to save it in db
        console.log("Copy: create plan")
        try {
            await this.props.createCustomizedPlan({
                variables: {
                    startDate: sourceCopy.startDate,
                    endDate: sourceCopy.endDate,
                    numDays: sourceCopy.numDays,
                    tripDetails: {
                        coverPhotoId: sourceCopy.tripDetails.coverPhoto.id,
                        description: sourceCopy.tripDetails.description,
                        title: sourceCopy.tripDetails.title
                    },
                    tripGuruId: sourceCopy.tripGuru.id,
                    orderingUserId: userId,
                    orderStatus: 'NewOrder'
                }
            })
            .then( (response) => {
                sourceCopy.id = response.data.createCustomizedPlan.id
                sourceCopy.tripDetails.id = response.data.createCustomizedPlan.tripDetails.id
            })

            console.log("Copy: create itinerary days")
            // Use the flat days to create the itinerary days
            await this.props.createAllItineraryDays({
                variables: {
                    id: sourceCopy.tripDetails.id,
                    itineraryDays: flatItineraryDays
                }
            })
            .then( (response) => {
                console.log("Copy: create itinerary days - done")
                response.data.updateTripDetails.itineraryDays.map((day, index) => {
                    sourceCopy.tripDetails.itineraryDays[index].id = day.id    
                })
            })
            // Link all notes to days
            console.log("Copy: assign notes")
            await Promise.all(sourceCopy.tripDetails.itineraryDays.filter(day => {
                return day.notes && day.notes.length > 0
            }).map(dayWithNotes => {
                return dayWithNotes.notes.map(note => {
                    return this.props.linkIterneraryDayAndNote({
                        variables: {
                          itineraryDayId: dayWithNotes.id,
                          noteId: note.id
                        }
                      })    
                })            
            })
            )
            // Create all events in each day
            console.log("Copy: copy events")
            return await Promise.all(sourceCopy.tripDetails.itineraryDays.map(day => {
                return this.props.updateItineraryDay({
                    variables: day
                })
            }))
            .then( (response) => {
                return sourceCopy
            })  
        } catch (err) {
            console.error(err)
        }
    }

    checkForPlanCopy = async (planId, userId) => {
        let tripId = ''
        if (planId) {
            this.setState({waiting: true})
            let trip = await this.copyExistingPlan(planId, userId)
            if (trip) {
                tripId = trip.id
            }
            this.setState({waiting: false})
        }
        return tripId
    }
    
    handleSubmit = async (values) => {
        this.setState({
            saving: true
          });

        if (!this.state.actualUser) {
            const auth0IdToken = window.localStorage.getItem('auth0IdToken')
            let invitedUser
            fetch(config.dbConnectionsApi + `signup`, {
                method: 'POST',
                headers: {
                'content-type': 'application/json',
                authorization: `Bearer ${auth0IdToken}`
                },
                body: JSON.stringify({
                    "client_id": config.clientId,
                    "connection": "Username-Password-Authentication",
                    "email": values.email,
                    "password": this.makeRandomPass(),
                    "user_metadata": { "name": values.phone }
                }),
            })
            .then( (response) => {
                return response.json()
            })
            .then((json) =>
                this.props.createUser({
                    variables: {
                        email: values.email,
                        firstName: values.firstName,
                        lastName: values.lastName,
                        phone: values.phone,
                        externalId: 'auth0|' + json._id
                    }
                })
            )
            .then(async (result) => {
                this.setState({
                    saving: false
                });
                let userId = result.data.createUser.id
                this.props.history.push({
                    pathname: '/create-trip/' + await this.checkForPlanCopy(values.plan, userId),
                    state: {
                        invitedUserId: userId
                    }
                })
            })
        }
        // Just move - assign the actual user to the trip
        else {
            this.props.history.push({
                pathname: '/create-trip/' + await this.checkForPlanCopy(values.plan, this.state.actualUser.id),
                state: {
                    invitedUserId: this.state.actualUser.id
                }
            })
        }
    }

  makeRandomPass() {
    var text = ''
    var possible = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789@#$%^&*'

    for (var i = 0; i < 9; i++) text += possible.charAt(Math.floor(Math.random() * possible.length))

    return text
  }

  loadUserByEmail = async event => {
    let theEmail = event.target.value
    if (theEmail && (!this.state.actualUser || theEmail != this.state.email)) {
      this.props.client
        .query({
          query: loadUserByEmailQuery,
          variables: {
            email: theEmail
          }
        })
        .then(result => {
          if (result.data.allUsers && result.data.allUsers.length > 0) {
            let user = result.data.allUsers[0]
            this.setActualUser(user)
          } else if (this.state.actualUser) {
            this.setState({
              actualUser: null,
              firstName: '',
              lastName: '',
              phone: ''
            })
          }
        })
    }
  }

  loadUserByPhone = async event => {
    let thePhone = event.target.value
    if (thePhone && (!this.state.actualUser || thePhone != this.state.phone)) {
      this.props.client
        .query({
          query: loadUserByPhoneQuery,
          variables: {
            phone: thePhone
          }
        })
        .then(result => {
          if (result.data.allUsers && result.data.allUsers.length > 0) {
            let user = result.data.allUsers[0]
            this.setActualUser(user)
          } else if (this.state.actualUser) {
            this.setState({
              actualUser: null,
              firstName: '',
              lastName: '',
              email: ''
            })
          }
        })
    }
  }

  setActualUser = user => {
    let profile = user.userProfile
    this.setState({
      actualUser: user,
      firstName: profile.firstName,
      lastName: profile.lastName,
      phone: profile.phone,
      email: profile.email
    })
  }

  render() {
    const { t } = this.props

    if (this.props.loading) {
      return <Loader showLoader={true} />
    }
    if (!this.props.user.plannerProfile || !this.props.user.plannerProfile.allowPrepaidTrips) {
      this.props.redirect()
    }

        let value 

        return (
            <div className="steps-screen__form">
                <div className="steps-screen__form-title">
                    {t('prepaid_order')}
                </div>
                <div className="steps-screen__form-subtitle">
                    {t("prepaid_user")}
                </div>
                <Form
                    onSubmit={this.handleSubmit}
                    submitBtnClassname="btn btn-lg btn-primary btn-danger"
                    submitBtnName={t('main:save_continue')}
                    >
                    <div className="row">
                        <div className="form-group clearfix">
                            <div className="col-md-9">
                                <TextInput
                                    id="firstName"
                                    placeholder="John"
                                    maxChars={50}
                                    validationFuncs={[validateRequired]}
                                    extraClass=""
                                    initialValue={this.state.firstName}
                                    label={t('main:first_name')}/>
                            </div>
                        </div>

                        <div className="form-group clearfix">
                            <div className="col-md-9">
                                <TextInput
                                id="lastName"
                                placeholder="Doe"
                                maxChars={50}
                                validationFuncs={[validateRequired]}
                                label={t('main:last_name')}
                                initialValue={this.state.lastName}
                                labelClass="steps-screen__form-input-label"
                                />
                            </div>
                        </div>

                        <div className="form-group clearfix">
                            <div className="col-md-9">
                                <TextInput
                                id="email"
                                maxChars={50}
                                validationFuncs={[validateRequired]}
                                label={t('main:email')}
                                onBlurExternal={this.loadUserByEmail}
                                initialValue={this.state.email}
                                labelClass="steps-screen__form-input-label"
                                />
                            </div>
                        </div>

                        <div className="form-group clearfix">
                            <div className="col-md-9">
                                <TextInput
                                    id="phone"
                                    maxChars={50}
                                    validationFuncs={[validateRequired]}
                                    onBlurExternal={this.loadUserByPhone}
                                    label={t('main:phone')}
                                    initialValue={this.state.phone}
                                    labelClass="steps-screen__form-input-label"/>
                            </div>
                        </div>
                        <div className="form-group clearfix">
                            <div className="col-md-4 ">
                                <SelectInput
                                    id="plan"
                                    options={this.getPlanOptions()}
                                    label={t('prepaid_plans')}
                                    simpleValue
                                    clearable={true}
                                    isGroup={false}/>
                            </div>
                        </div>
                    </div>
                </Form>
                <Loader showLoader={this.state.waiting} />
            </div>
    )
  }
}

const createUser = gql`
  mutation(
    $email: String!,
    $lastName: String!,
    $firstName: String!,
    $phone: String!,
    $externalId: String!
  ){
    createUser(
      auth0UserId: $externalId,
      userProfile: {
        email: $email,
        lastName: $lastName,
        firstName: $firstName,
        phone: $phone
      }
    ){
      id
    }
  }
`;


const loadUserByEmailQuery = gql`${LOAD_USER_PROFILE_BY_EMAIL}`
const loadUserByPhoneQuery = gql`${LOAD_USER_PROFILE_BY_PHONE}`
const loadSelectedPlan = gql`${queriesTP.GET_CUSTOMIZED_PLAN}`

const enhance = compose (
    translate('my_trips'),
    graphql(queriesTP.CREATE_ALL_ITINERARY_DAYS, {
        name: 'createAllItineraryDays'
    }),
    graphql(UPDATE_ITINERARY_DAY, {
        name: 'updateItineraryDay'
    }),
    graphql(queriesTP.LINK_ITINERARY_DAY_AND_NOTE, {
        name: 'linkIterneraryDayAndNote'
      }),
    
    graphql(queries.CREATE_CUSTOMIZED_PLAN, {
        name: 'createCustomizedPlan'
    }),
    graphql(queries.CREATE_TRIP_DETAILS, {
        name: 'createTripDetails'
    }),
    graphql(createUser, {
        name: 'createUser'
    }),
    graphql(GET_CUSTOMIZED_PLANS_LIST, {
        name: 'allCustomizedPlansQuery',
        options: props => ({
            variables: {
            tripGuruId: get(props, 'user.id', '')
            }
        })
    })
    )  

export default enhance(withApollo(PrepaidTrip))



// WEBPACK FOOTER //
// src/components/MyTrips/PrepaidTrip.js